import React from 'react';

import './details-button.styles.scss';

export const Button = ({text, url}) => (
    <div className="details-btn-wrapper">
        <div className="container">
            <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-wide btn-blue">{text}</a>
        </div>
    </div>
)